/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { PlatformState } from './platform_state';
export { ServerModule, platformDynamicServer, platformServer } from './server';
export { BEFORE_APP_SERIALIZED, INITIAL_CONFIG } from './tokens';
export { ServerTransferStateModule } from './transfer_state';
export { renderModule, renderModuleFactory } from './utils';
export { ɵINTERNAL_SERVER_PLATFORM_PROVIDERS, ɵSERVER_RENDER_PROVIDERS, ɵServerRendererFactory2 } from './private_export';
export { VERSION } from './version';
//# sourceMappingURL=platform-server.js.map